// Styles.js
import { styled } from "@mui/material/styles";
import { Box, Paper, TableContainer } from "@mui/material";

const jakartaRootSx = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiMenuItem-root, & .MuiTableCell-root, & .MuiChip-label, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiTableBody-root .MuiTableRow-root.MuiTableRow-hover:hover": {
    backgroundColor: "#ECF1F7",
  },
};

export const PageContainer = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  padding: theme.spacing(4),
  background: "transparent",
  backgroundColor: "transparent",
  minHeight: "100vh",
}));

export const CardContainer = styled(Paper)(({ theme }) => ({
  ...jakartaRootSx,
  display: "flex",
  flexDirection: "column",
  padding: "20px",
  width: "calc(100% - 10px)",
  maxWidth: "calc(100% - 10px)",
  minWidth: 0,
  borderRadius: "12px",
  background: "transparent",
  backgroundColor: "transparent",
  margin: "0 auto",
  boxSizing: "border-box",
}));

export const FiltersContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  alignSelf: "stretch",
  padding: theme.spacing(0, 0, 3, 0),
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(2),
  marginTop: 0,
  flexWrap: "wrap",
  background: "transparent",
}));

export const TitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

export const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: "12px",
  border: `1px solid ${theme.palette.divider}`,
  maxWidth: "100%",
  overflowX: "auto",
  overflowY: "auto",
  height: 505,
  background: "#fff",
  "& .MuiTableCell-root": {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
}));

export const FooterContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  justifyContent: "flex-start",
  paddingLeft: theme.spacing(0.5),
}));
